export default "__VITE_ASSET__Cfc0mgCz__"